import { ValidatorProvider } from '@dofleini/validator';
import { Form } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { CACHE_KEY_LIST_PROTECTED_AREA } from '@/modules/configuration/contants/protectedArea';
import ProtectedAreaApiService from '@/modules/configuration/services/ProtectedAreaApiService';
import { renderMunicipality, renderProvince } from '@/utils/location';
import SelectElementCmp from '@/utils/SelectElementCmp';

import style from './index.less';

const ProtectedAreaSelect = ({ value, onChange, filters, ...props }) => {
  const currentValue = value && typeof value === 'object' ? value._id : value;
  
  const onRenderItem = useCallback(({ name, address }) => {
    return <div>
      <div className="flex items-center truncate">
        <div className="font-semibold">{name}</div>
      </div>
      <div className={classNames(style.itemsContainer, 'flex items-center truncate')}>
        {address?.province &&
        <div className="element-contact text-xs truncate">{renderProvince(address?.province)}</div>}
        {address?.municipality &&
        <div className="element-contact text-xs truncate">{renderMunicipality(address?.municipality)}</div>}
      </div>
    </div>;
  }, []);
  
  return (
    <>
      <div className={classNames('w-full', style.container)}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_PROTECTED_AREA}
          filters={{ ...filters }}
          service={ProtectedAreaApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          sort={{ name: 1 }}
          customMapItem={(v) => ({ ...v, name: `${v.name || ''}` })}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

ProtectedAreaSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  showContact: PropTypes.bool,
  filters: PropTypes.object
};

export default memo(ProtectedAreaSelect);

export const renderProtectedAreaSelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <ProtectedAreaSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
